import { REWARDS } from './rewards';

export const APPLICATION = { REWARDS };
